module.exports = __webpack_public_path__ + "media/images/emblems/Grimisuat-696c0afb9fe5cf1e2e1b7900569230e8.png";